import styled from 'styled-components';

export const GlobalStyle = styled.div`
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap');
    width: 100%;
    height: 100%;
    font-family: 'Roboto', sans-serif;
    margin: 0;
    padding: 0;
`
